import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
export function HeroSection() {
  return <section className="bg-croon-purple pt-28 pb-20 px-6 flex flex-col items-center overflow-hidden" data-id="element-44">
      <div className="max-w-4xl mx-auto text-center" data-id="element-45">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-46">
          Turn your inspiration into real songs
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center justify-center mb-10" data-id="element-47">
          <div className="flex items-center gap-3 text-yellow-400 mb-2" data-id="element-48">
            <span className="text-2xl" data-id="element-49">🏆</span>
            <div className="text-center" data-id="element-50">
              <div className="text-lg md:text-xl font-bold mb-1" data-id="element-51">
                Best AI Music Generator
              </div>
              <div className="flex gap-1 justify-center" data-id="element-52">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-53">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-54" />
                  </svg>)}
              </div>
            </div>
            <span className="text-2xl" data-id="element-55">🏆</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center mb-12" data-id="element-56">
          <AppStoreButton data-id="element-57" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex justify-center" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/j8zKD4vxdrh9DVhpvDt3oQ/0x0ss_(26).png" alt="Croon App Hero" className="w-full max-w-[220px] md:max-w-[260px] h-auto rounded-[2rem] shadow-xl" data-id="element-59" />
        </motion.div>
      </div>
    </section>;
}